import { connect } from 'react-redux';

import { changeJourneyParam } from '@store/yourJourney/actions';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { basketSelectors } from '@store/basket/selectors';

import { Room } from './Room';

const mapStateToProps = (state) => ({
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
  roomIdsInBasket:
    basketSelectors.getBasketDetails(state)?.items?.map((room) => room?.bookable?.ids?.roomId) ||
    [],
});

const mapDispatchToProps = {
  changeJourneyParam,
};

export const RoomContainer: any = connect(mapStateToProps, mapDispatchToProps)(Room);
